import data from "../../.sourceflow/brands.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const brands_helper = new CollectionHelper(data);
